import { Injectable, inject } from '@angular/core';
import { HTTP_CP_Company, HTTP_CP_LoadBranding_Response } from '@api-new/companyservice';
import { environment } from '@environments/environment';
import { Store, select } from '@ngrx/store';
import { getAuthPagesBranding } from '@shared/store/auth/auth.action';
import { selectBranding } from '@shared/store/auth/auth.selectors';
import { selectCompany } from '@shared/store/company/company.selectors';
import { filter, take } from 'rxjs/operators';
import { AppState } from '../models/app-state.model';

@Injectable({
  providedIn: 'root',
})
export class GlobalBrandingService {
  private readonly store = inject(Store<AppState>);

  company: HTTP_CP_Company;
  branding: HTTP_CP_LoadBranding_Response;
  defaultColour = 'ffffff';

  private styleElement: HTMLLinkElement | null = null;

  initCompanyColorListener(): void {
    const domain = environment.mobileApp?.isMobileApp ? environment.mobileApp.defaultDomain : `${location.protocol}//${location.hostname}`;
    this.store.dispatch(
      getAuthPagesBranding({
        domain,
      }),
    );

    this.store.pipe(select(selectCompany), filter(Boolean)).subscribe((company: HTTP_CP_Company) => {
      this.company = company;
      this.setGlobalCompanyCssColours(company.primaryColor);
    });
    this.store.pipe(select(selectBranding), filter(Boolean), take(1)).subscribe((branding) => {
      this.branding = branding;
      this.loadCss(branding.cssFileUrl);
    });
  }

  getBrandingImageFolder(): string {
    return this.branding?.imageFolderUrl ?? 'assets/images/';
  }

  private setGlobalCompanyCssColours(colour: string): void {
    const partnerHexColour = colour || this.defaultColour;
    document.documentElement.style.setProperty('--company-color', `#${partnerHexColour}`);
    document.documentElement.style.setProperty('--company-color8', `#${partnerHexColour}CC`);
  }

  private loadCss(href: string): void {
    if (!this.styleElement) {
      this.styleElement = document.createElement('link');
      this.styleElement.rel = 'stylesheet';
      this.styleElement.type = 'text/css';
      this.styleElement.href = href;
      document.head.appendChild(this.styleElement);
    }
  }
}
